/**
 * AlertaLegal - Componente de UI para alertas jurídicas
 * Muestra alertas sobre topes confiscatorios (Fallo Gualtieri) y confiscación (Di Pardo)
 * CRÍTICO: Da argumentos de inconstitucionalidad sólidos para abogados
 */
import React from 'react'
import { AlertTriangle, Scale, Gavel } from 'lucide-react'

export default function AlertaLegal({ 
  falloGualtieri = false, 
  periodosAfectados = [], 
  tasaSustitucion = 0, 
  esConfiscatorio = false,
  haberBasico = 0,
  promedio = 0
}) {
  if (!falloGualtieri && !esConfiscatorio) return null

  return (
    <div className="bg-red-50 border-l-4 border-red-500 p-6 rounded-lg shadow-md mb-6">
      <div className="flex items-start gap-3 mb-4">
        <div className="p-2 bg-red-100 rounded-lg">
          <Gavel className="w-6 h-6 text-red-600" />
        </div>
        <div>
          <h3 className="text-lg font-bold text-red-800 mb-1">
            ¡Alerta Legal! - Argumento de Inconstitucionalidad Sólido
          </h3>
          <p className="text-sm text-red-600">
            CSJN: Corte Suprema de Justicia de la Nación
          </p>
        </div>
      </div>

      {falloGualtieri && (
        <div className="bg-white rounded-lg p-4 mb-4 border border-red-200">
          <div className="flex items-center gap-2 mb-2">
            <Scale className="w-4 h-4 text-red-600" />
            <h4 className="font-bold text-red-800">Fallo Gualtieri - Topes Confiscatorios</h4>
          </div>
          <p className="text-sm text-gray-700 mb-2">
            <strong>Se detectó aplicación de topes máximos</strong> en los períodos: <strong>{periodosAfectados.join(', ')}</strong>
          </p>
          <div className="bg-red-50 p-3 rounded border border-red-100">
            <p className="text-sm text-red-700">
              <strong>Doctrina CSJN:</strong> "La aplicación de topes máximos que reducen el haber por debajo del mínimo vital 
              constituye una confiscación de haberes (Art. 9 Ley 24.463)"
            </p>
          </div>
          <p className="text-xs text-gray-600 mt-2">
            <strong>Estrategia jurídica:</strong> Pedir reajuste de topes PBU/PC/PAP por inconstitucionalidad. 
            El haber promedio de ${promedio.toFixed(2)} con tope es judicializable.
          </p>
        </div>
      )}

      {esConfiscatorio && (
        <div className="bg-white rounded-lg p-4 mb-4 border border-orange-200">
          <div className="flex items-center gap-2 mb-2">
            <AlertTriangle className="w-4 h-4 text-orange-600" />
            <h4 className="font-bold text-orange-800">Caso Di Pardo - Confiscación Detectada</h4>
          </div>
          <p className="text-sm text-gray-700 mb-2">
            <strong>Tasa de Sustitución: {tasaSustitucion.toFixed(2)}%</strong> (Bajo el 70% esperado según Fallo "Quiroga")
          </p>
          <div className="bg-orange-50 p-3 rounded border border-orange-100">
            <p className="text-sm text-orange-700">
              <strong>Brecha confiscatoria:</strong> El haber básico (${haberBasico.toFixed(2)}) representa solo el {tasaSustitucion.toFixed(2)}% 
              del promedio de 120 meses (${promedio.toFixed(2)}). Se espera ≥70% según doctrina Quiroga.
            </p>
          </div>
          <p className="text-xs text-gray-600 mt-2">
            <strong>Base para demanda:</strong> La brecha entre el {tasaSustitucion.toFixed(2)}% obtenido y el 70% esperado (Fallo Quiroga) 
            constituye la base de la demanda por inconstitucionalidad. Art. 14 bis CN: "Prestaciones móviles".
          </p>
        </div>
      )}

      <div className="bg-gray-100 p-3 rounded">
        <p className="text-xs text-gray-600 text-center">
          <strong>Referencia:</strong> "El código es ahora una pieza de doctrina legal" - Genera estrategia, no solo números
        </p>
      </div>
    </div>
  )
}
